interface MinCostPerSquareFootFriendlyViewSummaryParameters {
    id: number;
    broadLineOfBusiness: string;
    state: string;
    constructionType: string;
    minCostPerSquareFoot: number;
    versionId: number;
}

export default class MinCostPerSquareFootFriendlyViewSummary {
	public id: number;
    public broadLineOfBusiness: string;
    public state: string;
    public constructionType: string;
    public minCostPerSquareFoot: number;
    public versionId: number;

    public constructor(params: MinCostPerSquareFootFriendlyViewSummaryParameters) {
        this.id = params.id;
        this.broadLineOfBusiness = params.broadLineOfBusiness;
        this.state = params.state;
        this.constructionType = params.constructionType;
        this.minCostPerSquareFoot = params.minCostPerSquareFoot;
        this.versionId = params.versionId;
    }
}